export default "__VITE_ASSET__PYGPv9HB__"